// ABOUTME: Action-menu entry that opens the servicedesk new-ticket screen with the current object pre-linked.
// ABOUTME: Only rendered for users who may create tickets in the active environment while the servicedesk is enabled.

import { Box } from "@mui/material";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ActionButton } from "./ActionButton";
import { ActionIcon } from "./ActionIcon";
import Text from "../../../../theme/text/Text";
import { ENV_TYPES } from "../../../Sidebar";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { useGetSettingsQuery } from "../../../../../newapi/global/generalApiSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { buildNewSupportTicketNavigation } from "../../../../../utils/newSupportTicketPrefill";

// props.linkedItem: payload from utils/supportTicketLinkedItems (null while the object loads)
// props.relationId: relation to preselect in the warehouse modal (ignored in the relation portal)
// props.onClose: closes the surrounding action popover before navigating
const CreateSupportTicketActionButton = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const hasCreateTicketPermission = useSelector((state) =>
        selectUserPermission(state, [isRelation ? UserPrivileges.RP_SUPPORT_MANAGE : UserPrivileges.SUPPORT_MANAGE])
    );

    // Same toggle the sidebar uses to decide whether the servicedesk section exists at all.
    const { data: servicedeskSettings } = useGetSettingsQuery("servicedesk");
    const servicedeskEnabled = !!servicedeskSettings?.some(
        (s) => s.key === "servicedesk_enabled" && (s.value === "true" || s.value === true)
    );

    if (!hasCreateTicketPermission || !servicedeskEnabled || !props.linkedItem) return null;

    const handleClick = () => {
        props.onClose?.();
        const { to, state } = buildNewSupportTicketNavigation(isRelation, {
            linkedItem: props.linkedItem,
            relationId: props.relationId,
        });
        navigate(to, { state });
    };

    return (
        <ActionButton onClick={handleClick}>
            <ActionIcon>
                <ConfirmationNumberOutlinedIcon fontSize="small"/>
            </ActionIcon>
            <Box>
                <Text>
                {t('create_support_ticket')}
                </Text>
            </Box>
        </ActionButton>
    );
};

export default CreateSupportTicketActionButton;
